"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * dodaje widoące zera do liczby
 * @param value liczba
 * @param minLength minimalna, wynikowa długośc tekstu, domyslnie 2
 */
function padNumber(value, minLength) {
    if (minLength === void 0) { minLength = 2; }
    var result = '' + value;
    while (result.length < minLength) {
        result = '0' + result;
    }
    return result;
}
exports.default = padNumber;
//# sourceMappingURL=padNumber.js.map